// extracted by mini-css-extract-plugin
export default {"headerBar":"_J-z","pointsSection":"aK-z","goToDashboard":"bK-z"};